export const WINDOW_MARGIN_PX = 200;
export const TAB_MARGIN_PX = 20;
